import { render, staticRenderFns } from "./InventoryApproval.vue?vue&type=template&id=2354b3f4&scoped=true&"
import script from "./InventoryApproval.vue?vue&type=script&lang=js&"
export * from "./InventoryApproval.vue?vue&type=script&lang=js&"
import style0 from "./InventoryApproval.vue?vue&type=style&index=0&id=2354b3f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354b3f4",
  null
  
)

export default component.exports